import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { SuperadminService } from 'src/app/services/superadmin/superadmin.service';

@Component({
  selector: 'app-group-branch',
  templateUrl: './group-branch.component.html',
  styleUrls: ['./group-branch.component.css']
})
export class GroupBranchComponent implements OnInit {

  constructor(private superadminservice: SuperadminService,private globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }
  BranchList=[];
  SearchModel={
    SchoolID:this.globalHelper.GetLoginToken().SchoolID
  } 
  BindBranch() {
    this.spinnerService.show();
    this.superadminservice.BindBranch(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.BranchList = response.BranchList;
      this.spinnerService.hide();

    });
  };

  ngOnInit() {
    this.BindBranch();
  }

}
